import Popover from "components/Popover";
import AskPaperTagTooltip from "components/Popover/AskPaperTagTooltip/AskPaperTagTooltip";
import { Paper } from "helpers/api";
import useLabels from "hooks/useLabels";
import { useAppSelector } from "hooks/useStore";
import { useState } from "react";
import Tag from "../Tag";
import { AskPaperIcon } from "design_system";

interface AskPaperTagProps {
  onClickAskPaper: () => void;
  paper: Paper;
  isCompact?: boolean;
  interactionId: string;
}

function AskPaperTag({
  paper,
  onClickAskPaper,
  isCompact = false,
  interactionId,
}: AskPaperTagProps) {
  const [tagLabels] = useLabels("tooltips.ask-this-paper-tag");
  const isMobile = useAppSelector((state) => state.setting.isMobile);

  const [tooltipInstance, setTooltipInstance] = useState<any>(null);

  const closeTooltip = () => {
    tooltipInstance?.hide();
  };

  return (
    <Popover
      interactive
      placement="top"
      trigger="mouseenter click"
      tooltipContent={
        <AskPaperTagTooltip
          closeTooltip={closeTooltip}
          onClickAskPaper={onClickAskPaper}
          paper={paper}
          interactionId={interactionId}
        />
      }
      onShown={(instance: any) => {
        setTooltipInstance(instance);
      }}
      onHidden={(instance: any) => {
        setTooltipInstance(instance);
      }}
    >
      {isCompact ? (
        <div className="p-1">
          <AskPaperIcon size="sm" />
        </div>
      ) : (
        <button>
          <Tag
            label={tagLabels["ask-this-paper"]}
            icon={<AskPaperIcon size="sm" />}
            data-testid="ask-paper-tag"
            onClick={(e) => {
              if (isMobile) {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
          />
        </button>
      )}
    </Popover>
  );
}

export default AskPaperTag;
